<template>
  <div>
    <div class="grid gap-6 sm:grid-cols-1 md:grid-cols-5 lg:grid-cols-3 xl:grid-cols-4">
      <div class="sm:col-span-1 md:col-span-3 lg:col-span-2 xl:col-span-3">
        <strategy-chart :data="data"> </strategy-chart>
      </div>
      <div class="sm:col-span-1 md:col-span-2 lg:col-auto xl:col-auto">
        <card-statistic :investment_statistic="data.tr_statistics" />
      </div>
    </div>
    <div class="grid grid-cols-3 gap-3 sm:grid-cols-5 sm:gap-6">
      <strategy-details-card-component
        title="Volume"
        :value="data.orders.reduce((sum, o) => sum + o.volume, 0)"
        :num="true"
      />
      <strategy-details-card-component title="Operações" :value="data.tr_statistics.num_trades" :num="true" />
      <strategy-details-card-component
        title="Fator de lucro"
        :value="parseFloat(data.tr_statistics.profit_factor)"
        :fac="true"
      />
      <strategy-details-card-component title="Resultado" :value="data.tr_statistics.net_profit_loss" :cash="true" />

      <strategy-details-card-component
        title="Taxa acerto"
        :value="data.tr_statistics.win_ratio"
        :percentage="true"
        :value_color="50"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    StrategyChart: () => import("../strategy/strategy-chart.component"),
    StrategyDetailsCardComponent: () => import("../strategy/strategy-details-card.component.vue"),
    CardStatistic: () => import("../strategy/strategy-card.component"),
  },
  props: {
    data: { type: Object },
  },
};
</script>

<style></style>
